import { undoConstants } from '../constants';

const initialState = {
    // Newest entry last. Each entry: { id, label, undo } where `undo` is the
    // server snapshot returned by the value/formula update endpoints.
    stack: [],
    undoing: false,
    undoError: null,
};

export function undo(state = initialState, action) {
    switch (action.type) {
        case undoConstants.PUSH_UNDO: {
            const stack = [...state.stack, action.entry];
            return {
                ...state,
                stack: stack.slice(-undoConstants.MAX_UNDO_ENTRIES),
            };
        }
        case undoConstants.CLEAR_UNDO: {
            return { ...state, stack: [] };
        }

        case undoConstants.UNDO_REQUEST: {
            return {
                ...state,
                undoing: true,
                undoError: null,
                // Pop optimistically so a second Ctrl+Z can't send the same entry twice.
                stack: state.stack.filter((entry) => entry.id !== action.entry.id),
            };
        }
        case undoConstants.UNDO_SUCCESS: {
            return { ...state, undoing: false };
        }
        case undoConstants.UNDO_FAILURE: {
            return {
                ...state,
                undoing: false,
                undoError: action.error,
                // Put the entry back when the failure may be temporary.
                stack: action.restore
                    ? [...state.stack, action.entry].slice(-undoConstants.MAX_UNDO_ENTRIES)
                    : state.stack,
            };
        }

        default:
            return state;
    }
}
